import { crmRequest } from '@meta-vue/util'
// 获取用户当前状态
export const querySeatState = () =>
  crmRequest('/callcenter-app/extension/queryExtensionStatus', {
    method: 'get',
    silent: true
  })
